module.exports = __webpack_public_path__ + "img/AMWETCarousel_upperBack.64a010c5.webp";